import { Card, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { m } from 'framer-motion';
// next
import NextLink from 'next/link';
import { ServiceProps } from 'src/@types/service';
import Image from 'src/components/NextSanityImage';
import { useResponsive } from 'src/hooks';
import Routes from 'src/routes';
// components
import { TextMaxLine } from '../../components';
import { varHover, varTranHover } from '../../components/animate';

// ----------------------------------------------------------------------

type Props = {
  service: ServiceProps;
};

export default function ServiceItem({ service }: Props) {
  const { title, header, slug } = service;
  const isMobile = useResponsive('down', 'md');

  return (
    <div>
      <Card
        component={m.div}
        whileHover="hover"
        sx={{
          '&:hover': {
            boxShadow: (theme) => theme.customShadows.z24,
          },
        }}
      >
        <NextLink href={Routes.service('[slug]')} as={Routes.service(slug.current)}>
          <a>
            <Box sx={{ overflow: 'hidden' }}>
              <m.div variants={varHover(1.1)} transition={varTranHover()}>
                <Image
                  alt={slug.current}
                  src={header}
                  ratio={isMobile ? '16/9' : '4/3'}
                  layout="intrinsic"
                  width={500}
                  height={200}
                />
              </m.div>
            </Box>
          </a>
        </NextLink>
      </Card>
      <Stack spacing={0.5} sx={{ px: { xs: 0.5, sm: 1, md: 1 }, py: { xs: 2 } }}>
        {!isMobile && (
          <Typography variant="body3" sx={{ color: 'text.secondary' }}>
            Tjeneste
          </Typography>
        )}
        <NextLink href={Routes.service('[slug]')} as={Routes.service(slug.current)} passHref>
          <TextMaxLine variant={isMobile ? 'h6' : 'h5'} asLink>
            {title}
          </TextMaxLine>
        </NextLink>
      </Stack>
    </div>
  );
}
